<div id="loader">
	<div></div>
	<div></div>
	<div></div>
</div>
